var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#FFF8CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V23C10.9998 23.5046 11.1904 23.9906 11.5335 24.3605C11.8766 24.7305 12.3468 24.9572 12.85 24.995L13 25H16V27H13C11.9391 27 10.9217 26.5786 10.1716 25.8284C9.42143 25.0783 9 24.0609 9 23V21H11ZM24 16L28.4 27H26.245L25.044 24H20.954L19.755 27H17.601L22 16H24ZM23 18.885L21.753 22H24.245L23 18.885ZM14 8V10H18V17H14V20H12V17H8V10H12V8H14ZM23 9C24.0609 9 25.0783 9.42143 25.8284 10.1716C26.5786 10.9217 27 11.9391 27 13V15H25V13C25 12.4696 24.7893 11.9609 24.4142 11.5858C24.0391 11.2107 23.5304 11 23 11H20V9H23ZM12 12H10V15H12V12ZM16 12H14V15H16V12Z",
    fill: "url(#paint0_linear_458_2169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_2169",
    x1: 28.4,
    y1: 17.5888,
    x2: 8.00532,
    y2: 17.9182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2800D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change-Language.a329b1d6e7f9c5147674e1b0f4ad3c07.svg";
export { ForwardRef as ReactComponent };